/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusBenutzerverwaltungEinstellungenDto } from '../../models/lexplus-benutzerverwaltung-einstellungen-dto';
import { LexplusUpdateBenutzerverwaltungEinstellungenDto } from '../../models/lexplus-update-benutzerverwaltung-einstellungen-dto';

export interface BenutzerverwaltungEinstellungenControllerUpdateV1$Params {
      body: LexplusUpdateBenutzerverwaltungEinstellungenDto
}

export function benutzerverwaltungEinstellungenControllerUpdateV1(http: HttpClient, rootUrl: string, params: BenutzerverwaltungEinstellungenControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusBenutzerverwaltungEinstellungenDto>> {
  const rb = new RequestBuilder(rootUrl, benutzerverwaltungEinstellungenControllerUpdateV1.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusBenutzerverwaltungEinstellungenDto>;
    })
  );
}

benutzerverwaltungEinstellungenControllerUpdateV1.PATH = '/v1/benutzerverwaltung/einstellungen';
